import { render, staticRenderFns } from "./WsUpdateDialogCompare.vue?vue&type=template&id=251840b5&"
import script from "./WsUpdateDialogCompare.vue?vue&type=script&lang=js&"
export * from "./WsUpdateDialogCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports